import { render, staticRenderFns } from "./CustomerInviteForm.vue?vue&type=template&id=be33a340&scoped=true"
import script from "./CustomerInviteForm.vue?vue&type=script&lang=js"
export * from "./CustomerInviteForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerInviteForm.vue?vue&type=style&index=0&id=be33a340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be33a340",
  null
  
)

export default component.exports